import React, { useState, useEffect } from 'react';
import {
    Row, Col, Accordion, AccordionBody, AccordionHeader, AccordionItem, Card, CardBody, CardTitle, CardText
} from 'reactstrap';
import { useTranslation } from "react-i18next";
import { } from 'reactstrap';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import StandartPage from '../Layouts/Shared/_StandartPage';

export default function Dashboard() {

    const { t } = useTranslation();
    const navigate = useNavigate();

    const [seed, setSeed] = useState(0);
    const [data, setData] = useState(null);

    const [open, setOpen] = useState('1');
    const toggle = (id) => {
        if (open === id) {
            setOpen();
        } else {
            setOpen(id);
        }
    };

    return (
        <StandartPage title={t('pages.dashboard.title')} >
            <React.Fragment>
                <ToastContainer />
                <Row>
                    <Col className="col-12 p-2 container">

                        <>
                            <Card className="my-2 p-4">
                                <CardBody>
                                    <CardTitle tag="h5" className='mb-4'>
                                        {t('pages.dashboard.label.announcements')}
                                    </CardTitle>
                                    <CardText>
                                        <Accordion open={open} toggle={toggle}>
                                            <AccordionItem>
                                                <AccordionHeader targetId="1"> {t('pages.dashboard.label.announcements.announcement-1.title')}</AccordionHeader>
                                                <AccordionBody accordionId="1">
                                                    <span dangerouslySetInnerHTML={{
                                                        __html: t('pages.dashboard.label.announcements.announcement-1.message')
                                                    }}></span>
                                                </AccordionBody>
                                            </AccordionItem>
                                            <AccordionItem className='d-none'>
                                                <AccordionHeader targetId="2"> {t('pages.dashboard.label.announcements.announcement-2.title')}</AccordionHeader>
                                                <AccordionBody accordionId="2">
                                                    <span dangerouslySetInnerHTML={{
                                                        __html: t('pages.dashboard.label.announcements.announcement-2.message')
                                                    }}></span>
                                                </AccordionBody>
                                            </AccordionItem>
                                            <AccordionItem className='d-none'>
                                                <AccordionHeader targetId="3"> {t('pages.dashboard.label.announcements.announcement-3.title')}</AccordionHeader>
                                                <AccordionBody accordionId="3">
                                                    <span dangerouslySetInnerHTML={{
                                                        __html: t('pages.dashboard.label.announcements.announcement-3.message')
                                                    }}></span>
                                                </AccordionBody>
                                            </AccordionItem>
                                        </Accordion>
                                    </CardText>
                                </CardBody>
                            </Card>
                        </>
                    </Col>
                </Row>
            </React.Fragment>
        </StandartPage>
    )

}